/**
 * useGpsLive — stream simulado de telemetría sobre los devices mock.
 *
 * Solo las unidades EN MOVIMIENTO derivan posición + oscilan velocidad/rumbo,
 * a intervalo regular. Da el "look vivo" del monitoreo sin backend.
 *
 * TODO(back): reemplazar por suscripción al stream WS del MS-GPS-TRACKER
 * (mantener la misma shape: { [deviceId]: { pos, velocidadKmh, rumbo } }).
 */
import { useEffect, useState } from 'react';

export function useGpsLive(devices, intervalMs = 3000) {
  const [live, setLive] = useState({});

  // Semilla inicial — un valor por device.
  useEffect(() => {
    const seed = {};
    for (const d of devices) {
      seed[d.id] = { pos: d.pos, velocidadKmh: d.velocidadKmh, rumbo: d.rumbo };
    }
    setLive(seed);
  }, [devices]);

  // Tick — solo mueve a los que estén en movimiento.
  useEffect(() => {
    if (devices.length === 0) return undefined;
    const moving = devices.filter((d) => d.estado === 'movimiento');
    if (moving.length === 0) return undefined;
    const t = setInterval(() => {
      setLive((prev) => {
        const next = { ...prev };
        for (const d of moving) {
          const cur = prev[d.id] ?? { pos: d.pos, velocidadKmh: d.velocidadKmh, rumbo: d.rumbo };
          const rad = (cur.rumbo * Math.PI) / 180;
          const step = 0.0007 + Math.random() * 0.0004;
          next[d.id] = {
            pos: {
              lat: cur.pos.lat + Math.cos(rad) * step,
              lng: cur.pos.lng + Math.sin(rad) * step,
            },
            velocidadKmh: Math.max(
              8,
              Math.min(d.velocidadMaxKmh + 4, Math.round(cur.velocidadKmh + (Math.random() - 0.5) * 8)),
            ),
            rumbo: (cur.rumbo + Math.round((Math.random() - 0.5) * 18) + 360) % 360,
          };
        }
        return next;
      });
    }, intervalMs);
    return () => clearInterval(t);
  }, [devices, intervalMs]);

  return live;
}
